import React, { useState } from 'react';
import MainMenu from './games//MainMenu';
import RiskSequenceGame from './games/RiskSequenceGame';
import AuditMemoryGame from './games/AuditMemoryGame';
import ShootingGame from './games/ShootingGame';
import CatchTheFraudsterGame from './games/CatchTheFraudsterGame';

const Gamified = () => {
  const [selectedGame, setSelectedGame] = useState(null);

  const handleSelectGame = (gameId) => setSelectedGame(gameId);
  const handleBackToMenu = () => setSelectedGame(null);

  return (
    <div className="min-h-screen bg-gray-100">
      {selectedGame === null && <MainMenu onSelectGame={handleSelectGame} />}
      {selectedGame === 'auditGuessing' && <RiskSequenceGame onBack={handleBackToMenu} />}
      {selectedGame === 'auditMemory' && <AuditMemoryGame onBack={handleBackToMenu} />}
      {selectedGame === 'shooting' && <ShootingGame onBack={handleBackToMenu} />}
      {selectedGame === 'catchFraudster' && <CatchTheFraudsterGame onBack={handleBackToMenu} />}

    </div>
  );
};


export default Gamified;
